import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { QRCodeComponent } from 'angularx-qrcode';

@Component({
  selector: 'anihis-desktop-app-download-links',
  standalone: true,
  imports: [QRCodeComponent],
  templateUrl: './desktop-app-download-links.component.html',
  styleUrl: './desktop-app-download-links.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesktopAppDownloadLinksComponent {
  /** URL encoded in the QR code (typically this page or a store landing URL). */
  @Input({ required: true }) qrUrl!: string;

  @Input({ required: true }) appStoreUrl!: string;

  @Input({ required: true }) playStoreUrl!: string;
}
